<template>
    <tr>
        <td class="text-center priority-3">
            <!-- <a href="javascript:;" @click="$emit('change-status', task)"> -->
            <span class="status" :class="[compilationProgress === 0 ? 'not-started' : compilationProgress === 100 ? 'completed' : 'running']"></span>
            <!-- </a> -->
        </td>
        <td>
            <progress-bar :progress="compilationProgress"></progress-bar>
        </td>
        <!-- <td @click="detail">{{ task.id }}</td> -->
        <td>{{ task.task_name }}</td>
        <!-- <td @click="detail" class="text-center">{{ task.type.text }}</td> -->
        <!-- <td @click="detail" style="width:40%">
            <template v-if="task.metas.length">
                <span v-for="meta in task.metas" :key="meta.meta_key">
                    {{ meta.meta_key }} {{ meta.value }}<br>
                </span>
            </template>
        </td> -->
        <td class="priority-3">
            {{ task.user.username }}
        </td>
        <td>
            <span v-if="taskDate">{{ $date(taskDate).format('DD-MM-YYYY') }}</span>
        </td>
        <!-- <td>
            <span v-if="compilationDate">{{ $date(compilationDate).format('DD-MM-YYYY HH:mm') }}</span>
        </td> -->
        <td class="text-center priority-3">
            {{ taskNonCompliance }}
        </td>
        <td class="text-center priority-3">
            <font-awesome-icon v-if="hasPicture" :icon="['far', 'images']" />
        </td>
        <td class="text-right">
            <a title="Compila questionario" href="javascript:;" v-if="task.user.id === this.currentUser.id && (surveyPath && task.task_status === 0)" class="btn btn-sm btn-info text-light" @click="gotoSurvey">
                <font-awesome-icon icon="poll-h" /> <span>QUESTIONARIO</span>
            </a>
            <a
                v-if="task.compilation && compilationProgress > 0"
                title="Genera PDF"
                :href="`${apiUrl}/compilation/pdf/${task.compilation.id}`"
                target="_blank"
                class="btn btn-sm btn-secondary text-light"
            >
                <font-awesome-icon icon="file-pdf" /> <span>PDF</span>
            </a>
            <!-- <a title="Elimina tratta" href="javascript:;" class="btn btn-sm btn-danger" @click="$emit('delete', task)">
                <font-awesome-icon icon="trash-alt" /> <span>ELIMINA</span>
            </a> -->
        </td>
    </tr>
</template>

<script>
import {
    API_URL
} from '@/common/config'
import {
    mapGetters
} from 'vuex'
export default {
    name: 'tasks-table-row',
    props: {
        task: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            apiUrl: API_URL
        }
    },
    methods: {
        detail () {
            this.$emit('edit', this.task)
        },
        gotoSurvey () {
            this.$router.push({
                name: 'compiler',
                params: {
                    guid: this.surveyPath
                }
            })
            // window.location.href = `/survey?${this.surveyPath}`
        },
        pdfSurvey () {
            window.location.href = `${API_URL}/compilation/pdf/${this.task.compilation.id}`
        }
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        surveyPath () {
            let surveyUrlParams = this.task.metas.find(m => {
                return m.meta_key === 'survey_url_params'
            })
            if (surveyUrlParams) return surveyUrlParams.value
            return false
        },
        compilationProgress () {
            return this.task.compilation ? this.task.compilation.progress : 0
        },
        taskDate () {
            let routeDate = this.task.metas.find(m => {
                return m.meta_key === 'route_date'
            })
            if (routeDate) return routeDate.value
            return false
        },
        compilationDate () {
            return this.task.compilation ? this.task.compilation.updated_at : false
        },
        taskNonCompliance () {
            if (this.task.compilation && this.task.compilation.responces) {
                return this.task.compilation.responces.filter((r) => {
                    return r.value === 'NC'
                }).length
            }
            return '--'
        },
        hasPicture () {
            if (this.task.compilation && this.task.compilation.json) {
                return this.task.compilation.json.includes('-file')
            }
            return false
        }
    },
    components: {
        ProgressBar: () => import('@/components/ProgressBar')
    }
}
</script>
